<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-card v-if="pageDetails">
      <div class="mb-3 w-100 d-flex align-items-center justify-content-between">
        <h1>Edit A Page</h1>
        <b-form-group label="Is Permenant?" v-slot="{ ariaDescribedby }">
          <div
            class="w-100 d-flex align-items-center justify-content-center"
            style="gap: 1rem"
          >
            <b-form-radio
              v-model="pageDetails.isDeletable"
              :aria-describedby="ariaDescribedby"
              name="isDeletable"
              :value="false"
            >
              Yes
            </b-form-radio>
            <b-form-radio
              v-model="pageDetails.isDeletable"
              :aria-describedby="ariaDescribedby"
              name="isDeletable"
              :value="true"
            >
              <NuxtLoadingIndicator />
            </b-form-radio>
          </div>
        </b-form-group>
      </div>
      <b-row>
        <b-col cols="6">
          <b-form @submit.prevent>
            <b-form-group label="Page Title" label-for="title">
              <b-form-input
                id="title"
                trim
                placeholder="About Us Or..."
                v-model="pageDetails.title"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="6">
          <b-form @submit.prevent>
            <b-form-group label="Page Link (Seperate With -)" label-for="link">
              <b-form-input
                dir="auto"
                id="link"
                trim
                placeholder="about-us"
                v-model="pageDetails.link"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="6">
          <language-picker
            :defaultLanguageId="pageDetails.languageId"
            @getLanguage="setLanguage"
            placeholder="Select Page Language"
          ></language-picker>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="pageShapeType" label="Page Shape">
            <b-form-select
              id="pageShapeType"
              v-model="pageDetails.pageShapeType"
              :options="shapeOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <menu-picker
            placeholder="Select Header Menu"
            :defaultMenuId="pageDetails.menuId"
            @getMenu="setMenu"
          ></menu-picker>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Page Content" label-for="page-content">
            <quillEditor
              ref="quillEditor"
              v-model="pageDetails.content"
              :options="editorOption"
            >
              <div id="toolbar" slot="toolbar" class="ql-toolbar ql-snow">
                <quill-toolbar></quill-toolbar>
              </div>
            </quillEditor>
          </b-form-group>
        </b-col>
        <b-col cols="6" class="my-1">
          <b-form @submit.prevent>
            <b-form-group label="Page Cover" label-for="imageFile">
              <b-form-file
                id="imageFile"
                v-model="pageImage"
                accept="image/*"
                @input="convertImageFileToBase64"
              ></b-form-file>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="6" class="my-1">
          <div v-if="imagePreview">
            <p>Page Cover Preview</p>
            <div class="position-relative">
              <img
                style="width: 100%; max-height: 20rem; object-fit: contain"
                :src="imagePreview"
                alt=""
              />
              <feather-icon
                icon="Trash2Icon"
                size="25"
                class="text-danger position-absolute"
                style="left: 1rem; top: 1rem; cursor: pointer"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button variant="primary" @click="sendPageUpdateRequest">
          Update Page
        </b-button>
      </div>
    </b-card>
    <library-image-picker
      @insertImage="insertImage"
      @insertVideo="insertVideo"
    ></library-image-picker>
  </b-overlay>
</template>
<script>
export default {
  title: "Edit A Page",
  data() {
    return {
      isLoading: false,
      pageImage: null,
      pageDetails: null,
      shapeOptions: [
        {
          value: null,
          text: "Please choose an option",
        },
        {
          value: 1,
          text: "Homepage",
        },
        {
          value: 2,
          text: "Blog",
        },
        {
          value: 3,
          text: "Contact Us",
        },
        {
          value: 4,
          text: "Representative",
        },
        {
          value: 5,
          text: "Service",
        },
        {
          value: 6,
          text: "Dynamic",
        },
      ],
      editorOption: {
        modules: {
          toolbar: {
            container: "#toolbar",
            handlers: {
              image: this.imageMethod,
              video: this.imageMethod,
            },
          },
        },
        // Some Quill options...
        theme: "snow",
      },
    };
  },
  mounted() {
    this.getASinglePage();
  },
  methods: {
    imageMethod() {
      this.$bvModal.show("library-image-picker-modal");
    },
    insertImage(imageUrl) {
      this.$refs.quillEditor.quill.insertEmbed(
        this.$refs.quillEditor.quill.getSelection().index,
        "image",
        imageUrl
      );
    },
    insertVideo(videoUrl) {
      this.$refs.quillEditor.quill.insertEmbed(
        this.$refs.quillEditor.quill.getSelection().index,
        "video",
        videoUrl
      );
    },
    setMenu(menu) {
      this.pageDetails.menuId = menu.menuId;
    },
    setLanguage(language) {
      this.pageDetails.languageId = language.languageId;
    },
    async getASinglePage() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASinglePage = new GetASinglePage(_this);
        getASinglePage.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASinglePage.fetch((response) => {
          if (response.isSuccess) {
            _this.pageDetails = response.data;
            // if (!_this.pageDetails.isStatic) {
            //   if (_this.pageDetails.link.includes("/pages/")) {
            //     _this.pageDetails.link =
            //       _this.pageDetails.link.split("/pages/")[1];
            //   }
            // }
            _this.pageImage = JSON.parse(
              JSON.stringify(_this.pageDetails.fileData)
            );
            _this.pageDetails.fileData = [];
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendPageUpdateRequest() {
      try {
        this.isLoading = true;
        if (!this.pageDetails.isStatic) {
          if (!this.pageDetails.link.startsWith("/")) {
            this.pageDetails.link = `/${this.pageDetails.link}`;
          }
          this.pageDetails.seourl = this.pageDetails.link;
        }
        let _this = this;
        let updateASinglePage = new UpdateASinglePage(_this);
        updateASinglePage.setRequestParamDataObj(_this.pageDetails);
        await updateASinglePage.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "Operation Was Successful",
                icon: "CheckIcon",
                variant: "success",
                text: "Page Updated Successfully",
              },
            });
            _this.getASinglePage();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    convertImageFileToBase64() {
      const reader = new FileReader();
      reader.readAsDataURL(this.pageImage);
      reader.onload = () => {
        this.pageDetails.fileData.push({
          base64: reader.result.split(",")[1],
          priority: 1,
          link: null,
          imageTitle: null,
        });
      };
    },
  },
  computed: {
    imagePreview() {
      if (this.pageImage[0] && typeof this.pageImage[0].base64 != "string") {
        return URL.createObjectURL(this.pageImage);
      } else {
        if (this.pageImage && this.pageImage[0] && this.pageImage[0].base64) {
          return `${process.env.pic}/${this.pageImage[0].base64}`;
        } else {
          return false;
        }
      }
    },
  },
  components: {
    BContainer,
    BPagination,
    BFormRow,
    BCard,
    BMedia,
    BAvatar,
    BCardText,
    BTable,
    BMediaAside,
    BMediaBody,
    BForm,
    BFormRadio,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BImg,
    BFormFile,
    BLink,
    BButton,
    BFormTextarea,
    BOverlay,
    BFormSelect,
    LanguagePicker,
    quillEditor,
    MenuPicker,
    LibraryImagePicker,
    QuillToolbar,
  },
};
import MenuPicker from "@/views/components/utils/MenuPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { GetASinglePage, UpdateASinglePage } from "@/libs/Api/Page";
import QuillToolbar from "@/views/components/utils/QuillToolbar.vue";
import LibraryImagePicker from "@/views/components/utils/LibraryImagePicker.vue";
import {
  BContainer,
  BPagination,
  BFormRow,
  BCard,
  BMedia,
  BAvatar,
  BCardText,
  BTable,
  BMediaAside,
  BMediaBody,
  BForm,
  BFormRadio,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BImg,
  BFormFile,
  BLink,
  BButton,
  BFormTextarea,
  BOverlay,
  BFormSelect,
} from "bootstrap-vue";
</script>
